import { renderSidebar } from '../shared/sidebar';
import { applySidebarPermissions } from '../componants/sidebar';

// === API endpoint & helpers (SIGNUP ONLY) ===
const API_URL = "https://script.google.com/macros/s/AKfycbzv34TCKiDriWh5hHmMxH18WNNg-FwlNyO3GIRQU7PtqKM0seT70cA4g4IpIXoAlYutyQ/exec";
const DEFAULT_DASHBOARD_PATH = '../dashboard/dashboard.html';

function getStoredUser() {
  try { return JSON.parse(localStorage.getItem('__vhb_user') || 'null'); }
  catch (_) { return null; }
}

function getStoredSession() {
  try { return JSON.parse(localStorage.getItem('__vhb_session') || 'null'); }
  catch (_) { return null; }
}

function clearStoredAuth() {
  try {
    localStorage.removeItem('__vhb_session');
    localStorage.removeItem('__vhb_user');
    localStorage.removeItem('__login_id');
  } catch (_) { }
}

function hasValidSession(session) {
  if (!session || !session.token) return false;
  if (session.expires_at) {
    const ts = typeof session.expires_at === 'string' ? Date.parse(session.expires_at) : Number(session.expires_at);
    if (!Number.isNaN(ts)) {
      return ts > Date.now();
    }
  }
  return true;
}

function normalizeSession(raw) {
  const now = Date.now();
  if (raw && typeof raw === 'object') {
    const token = raw.token || raw.id || raw.sessionToken;
    const expiresAtRaw = raw.expires_at || raw.expiry || raw.expiresAt;
    const expiresInSec = raw.expires_in_sec || raw.expiresInSec || raw.expiresIn;
    if (token) {
      if (expiresAtRaw) {
        const ts = typeof expiresAtRaw === 'string' ? Date.parse(expiresAtRaw) : Number(expiresAtRaw);
        if (!Number.isNaN(ts)) {
          return { token: String(token), expires_at: ts };
        }
      }
      if (expiresInSec) {
        const ttlMs = (parseInt(expiresInSec, 10) || 0) * 1000;
        return { token: String(token), expires_at: now + (ttlMs || 6 * 60 * 60 * 1000) };
      }
      return { token: String(token), expires_at: now + 6 * 60 * 60 * 1000 };
    }
  }
  return { token: 'session_' + now, expires_at: now + 6 * 60 * 60 * 1000 };
}

function redirectAfterAuth(user, session) {
  const normalizedSession = normalizeSession(session || {});
  try { localStorage.setItem('__vhb_session', JSON.stringify(normalizedSession)); } catch (_) { }
  try { localStorage.setItem('__vhb_user', JSON.stringify(user || {})); } catch (_) { }
  const target = DEFAULT_DASHBOARD_PATH;
  window.location.replace(target);
}

function setStatusSignup(msg, isError) {
  const st = document.getElementById('statusSu');
  if (!st) return;
  st.textContent = msg || '';
  st.classList.toggle('error', !!isError);
}

// Basic SHA-256 util
async function sha256(str) {
  const buf = new TextEncoder().encode(str);
  const hash = await crypto.subtle.digest('SHA-256', buf);
  return [...new Uint8Array(hash)].map(b => b.toString(16).padStart(2, '0')).join('');
}

function populateSidebar() {
  const user = getStoredUser();
  if (!user) return;
  const avatar = document.getElementById('avatar');
  const userName = document.getElementById('userName');
  const roleBadge = document.getElementById('roleBadge');
  if (avatar) {
    const initials = (user.firstname || user.lastname || 'VU').trim().slice(0, 2).toUpperCase();
    avatar.textContent = initials;
  }
  if (userName) userName.textContent = `${user.firstname || ''} ${user.lastname || ''}`.trim() || user.email || 'Utilisateur';
  if (roleBadge) {
    roleBadge.textContent = String(user.role || '').toUpperCase() || 'RESPONSABLE';
  }
  const navADN = document.getElementById('navADN');
}

function initSidebarControls() {
  const btnLogout = document.getElementById('btnLogout');
  if (btnLogout) {
    btnLogout.addEventListener('click', () => {
      clearStoredAuth();
      window.location.replace('../login/login.html');
    });
  }

  const hamburgerBtn = document.getElementById('hamburgerBtn');
  const sidebarClose = document.getElementById('sidebarClose');
  const sidebarOverlay = document.getElementById('sidebarOverlay');
  const sidebar = document.querySelector('.sidebar');

  if (!hamburgerBtn || !sidebar) return;

  const openSidebar = () => {
    sidebar.classList.add('active');
    if (sidebarOverlay) sidebarOverlay.classList.add('active');
    hamburgerBtn.setAttribute('aria-expanded', 'true');
  };

  const closeSidebar = () => {
    sidebar.classList.remove('active');
    if (sidebarOverlay) sidebarOverlay.classList.remove('active');
    hamburgerBtn.setAttribute('aria-expanded', 'false');
  };

  hamburgerBtn.addEventListener('click', openSidebar);
  if (sidebarClose) sidebarClose.addEventListener('click', closeSidebar);
  if (sidebarOverlay) sidebarOverlay.addEventListener('click', closeSidebar);
}

// Require session + role RESPONSABLE et render sidebar
(function enforceResponsable() {
  const user = getStoredUser();
  const session = getStoredSession();
  const sessionOk = hasValidSession(session);
  const role = String(user?.role || '').toUpperCase();
  if (!user || !user.email || !sessionOk || role !== 'RESPONSABLE') {
    const next = encodeURIComponent(location.pathname + location.search);
    window.location.replace('../login/login.html?next=' + next);
    return;
  }
  renderSidebar('signup');
  populateSidebar();
  applySidebarPermissions(user);
  initSidebarControls();
})();

// Signup form logic
(function () {
  const form = document.getElementById('signupForm');
  const btn = document.getElementById('btnSignup');
  if (!form || !btn) return;

  // Toggle password visibility
  (function () {
    const p1 = document.getElementById('su_password');
    const p2 = document.getElementById('su_password2');
    const t1 = document.getElementById('togglePass2');
    const t2 = document.getElementById('togglePass2c');
    if (p1 && t1) t1.addEventListener('click', () => {
      const isPass = p1.type === 'password';
      p1.type = isPass ? 'text' : 'password';
      t1.innerHTML = isPass ? '<i class="far fa-eye-slash"></i>' : '<i class="far fa-eye"></i>';
    });
    if (p2 && t2) t2.addEventListener('click', () => {
      const isPass = p2.type === 'password';
      p2.type = isPass ? 'text' : 'password';
      t2.innerHTML = isPass ? '<i class="far fa-eye-slash"></i>' : '<i class="far fa-eye"></i>';
    });
  })();

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    setStatusSignup('', false);
    const sess = getStoredSession();
    const user = getStoredUser();
    const role = String(user?.role || '').toUpperCase();
    if (!sess || !hasValidSession(sess) || role !== 'RESPONSABLE') {
      setStatusSignup('Création de compte réservée aux responsables connectés.', true);
      return;
    }

    const first = document.getElementById('su_firstname').value.trim();
    const last = document.getElementById('su_lastname').value.trim();
    const email = document.getElementById('su_email').value.trim();
    const phone = document.getElementById('su_phone').value.trim();
    const pw1 = document.getElementById('su_password').value;
    const pw2 = document.getElementById('su_password2').value;
    const terms = document.getElementById('su_terms').checked;

    if (!first || !last) { setStatusSignup('Indiquez votre prénom et votre nom.', true); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setStatusSignup('Adresse e‑mail invalide.', true); return; }
    if (String(phone || '').replace(/\D/g, '').length !== 10) { setStatusSignup('Numéro de téléphone invalide (10 chiffres).', true); return; }
    if (!pw1 || pw1.length < 6) { setStatusSignup('Mot de passe trop court (6+ caractères).', true); return; }
    if (pw1 !== pw2) { setStatusSignup('Les mots de passe ne correspondent pas.', true); return; }
    if (!terms) { setStatusSignup("Vous devez accepter les conditions d’utilisation.", true); return; }

    const original = btn.innerHTML; btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Création…';

    try {
      const hashedPw = await sha256(pw1);
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          mode: "signup",
          firstname: first,
          lastname: last,
          email: email,
          phone: phone,
          password: hashedPw,
          session_token: sess?.token || ''
        })
      });
      const data = await res.json();
      btn.disabled = false;
      btn.innerHTML = original;
      if (data.success) {
        setStatusSignup(data.message || 'Compte créé. Merci de vous connecter.', false);
      } else {
        setStatusSignup(data.error || 'Échec de création du compte.', true);
      }
    } catch (err) {
      btn.disabled = false;
      btn.innerHTML = original;
      setStatusSignup('Erreur: ' + (err.message || err), true);
    }
  });
})();
